import React from 'react';
import { CloseIcon } from '../../../assets/icons';

interface ChipProps {
    label: React.ReactNode;
  clearAction: () => void;
  style?: React.CSSProperties;
}

const Chip: React.FC<ChipProps> = ({ label, clearAction }) => {
  const handleClearClick = () => {
    clearAction();
  };

  return (
    <div className="flex items-center chip border  shadow-md rounded-md px-3 py-1 mr-2 bg-[#E3EFFC]" >
      <span className="chip-text mr-2">{label}</span>
      <button className="chip-clear flex items-center justify-center w-3 h-3  text-md hover: focus:outline-none" onClick={handleClearClick}>
    {<CloseIcon/>}
      </button>
    </div>
  );
};

export default Chip;